import { useState } from "react";
import { Hero } from "@/components/site/Hero";
import { Journey } from "@/components/site/Journey";
import { Services } from "@/components/site/Services";
import { Pricing } from "@/components/site/Pricing";
import { BookingForm } from "@/components/site/BookingForm";
import { GroupSignup } from "@/components/site/GroupSignup";
import { DonationForm } from "@/components/site/DonationForm";
import { Footer } from "@/components/site/Footer";
import { scrollTo } from "@/lib/api";

export default function Home() {
  const [service, setService] = useState("");
  const [duration, setDuration] = useState("60");

  const requestService = (name) => { setService(name); scrollTo("request"); };
  const book = (d) => { setDuration(d); scrollTo("request"); };

  return (
    <main data-testid="home-page">
      <Hero />
      <Journey />
      <Services onRequest={requestService} />
      <Pricing onBook={book} onGroup={() => scrollTo("group")} />
      <BookingForm service={service} setService={setService} duration={duration} setDuration={setDuration} />
      <section id="group" data-testid="group-section" className="px-6 md:px-16 py-24 md:py-32">
        <div className="max-w-2xl mb-14">
          <p className="eyebrow">Together we rise</p>
          <h2 className="font-display gold-text text-4xl md:text-5xl mt-3">Group Gatherings</h2>
          <p className="mt-5 text-base md:text-lg text-[#f7f1e1]/80">We learn from each other's experiences, share our stories and grow together. Group sessions are always free.</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          <GroupSignup />
          <div className="lg:mt-16"><DonationForm /></div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
